export default __webpack_public_path__ + "2d16f6271af5c3a1bad0730e2375c3e7.svg";